<template>
  <div class="welcome-container" ref="container">
    <!-- 高级粒子/星群背景 -->
    <canvas id="particles-canvas" class="particles-canvas"></canvas>
    
    <!-- 动态网格背景 -->
    <div class="grid-bg"></div>
    
    <!-- 浮动光球 -->
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>
    <div class="orb orb-4"></div>
    
    <!-- 鼠标跟随光效 -->
    <div class="mouse-follower" ref="mouseFollower" v-show="showMouseFollower"></div>
    
    <!-- 扫描线效果 -->
    <div class="scanline"></div>
    <div class="scanline scanline-2"></div>
    
    <!-- 欢迎内容 -->
    <div class="welcome-content">
      <!-- 时间显示 -->
      <div class="time-display">
        <span class="time-text">{{ currentTime }}</span>
      </div>
      
      <!-- 主标题 - 3D效果 -->
      <div class="title-3d-wrapper">
        <h1 class="title-3d">
          <span class="title-layer title-layer-back">NoAuth</span>
          <span class="title-layer title-layer-front">
            <span class="title-char" v-for="(char, i) in 'NoAuth'" :key="i" :style="{animationDelay: i * 0.08 + 's'}">
              {{ char === ' ' ? '\u00A0' : char }}
            </span>
          </span>
        </h1>
      </div>
      
      <!-- 霓虹副标题 -->
      <p class="neon-subtitle">
        <span class="subtitle-char" v-for="(char, i) in '高效 · 便捷 · 安全'" :key="i" :style="{animationDelay: 0.8 + i * 0.06 + 's'}">
          {{ char }}
        </span>
      </p>
      
      <!-- 动态分割线 -->
      <div class="neon-line">
        <span class="neon-line-inner"></span>
      </div>
      
      <!-- 功能入口卡片 -->
      <div class="feature-cards">
        <div class="feature-card" v-for="(feature, i) in features" :key="i" :style="{animationDelay: 1.5 + i * 0.15 + 's'}" @mouseenter="handleCardHover" @mouseleave="handleCardLeave">
          <div class="card-glow"></div>
          <div class="card-icon">{{ feature.icon }}</div>
          <div class="card-title">{{ feature.title }}</div>
          <div class="card-desc">{{ feature.desc }}</div>
        </div>
      </div>
      
      <!-- 技术栈徽章 -->
      <div class="tech-stack">
        <span class="tech-badge" v-for="(tech, i) in techs" :key="i" :style="{animationDelay: 2.5 + i * 0.1 + 's'}">
          <span class="badge-dot"></span>
          {{ tech }}
        </span>
      </div>
    </div>
    
    <!-- 底部状态 + 装饰 -->
    <div class="footer">
      <div class="corner-decor top-left"></div>
      <div class="corner-decor top-right"></div>
      <div class="corner-decor bottom-left"></div>
      <div class="corner-decor bottom-right"></div>
      
      <div class="status-indicator">
        <div class="pulse-ring"></div>
        <span class="status-text">SYSTEM ONLINE</span>
      </div>
      
      <div class="footer-decoration">
        <span class="decor-line"></span>
        <span class="decor-text">v2.0.0</span>
        <span class="decor-line"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      currentTime: '',
      timer: null,
      techs: ['Spring Boot', 'Vue.js', 'MySQL', 'Redis', 'K8s', 'Docker', 'Kafka', 'Nacos'],
      features: [
        { icon: '🚀', title: '高性能', desc: '微服务架构' },
        { icon: '🔒', title: '安全性', desc: '权限控制' },
        { icon: '⚡', title: '高可用', desc: '容器化部署' },
        { icon: '🎯', title: '易扩展', desc: '模块化设计' }
      ],
      particles: [],
      canvas: null,
      ctx: null,
      animationId: null,
      showMouseFollower: false,
      mouseFollowerTimeout: null
    }
  },
  methods: {
    updateTime () {
      const now = new Date()
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.currentTime = `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, '0')}.${String(now.getDate()).padStart(2, '0')} ${weekdays[now.getDay()]} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
    },
    initCanvas () {
      this.canvas = document.getElementById('particles-canvas')
      this.ctx = this.canvas.getContext('2d')
      this.resizeCanvas()
      this.createParticles()
      this.animateParticles()
      window.addEventListener('resize', () => this.resizeCanvas())
    },
    resizeCanvas () {
      if (!this.canvas) return
      this.canvas.width = window.innerWidth
      this.canvas.height = window.innerHeight
      this.createParticles()
    },
    createParticles () {
      this.particles = []
      const particleCount = Math.floor((window.innerWidth * window.innerHeight) / 15000)
      for (let i = 0; i < particleCount; i++) {
        this.particles.push({
          x: Math.random() * this.canvas.width,
          y: Math.random() * this.canvas.height,
          vx: (Math.random() - 0.5) * 0.6,
          vy: (Math.random() - 0.5) * 0.6,
          radius: Math.random() * 2.5 + 0.5,
          opacity: Math.random() * 0.6 + 0.2,
          color: Math.random() > 0.7 ? 'rgba(102, 126, 234,' : Math.random() > 0.5 ? 'rgba(255, 119, 114,' : 'rgba(255, 255, 255,'
        })
      }
    },
    animateParticles () {
      if (!this.ctx) return
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
      
      // 绘制连线
      for (let i = 0; i < this.particles.length; i++) {
        for (let j = i + 1; j < this.particles.length; j++) {
          const dx = this.particles[i].x - this.particles[j].x
          const dy = this.particles[i].y - this.particles[j].y
          const dist = Math.sqrt(dx * dx + dy * dy)
          
          if (dist < 150) {
            const alpha = (1 - dist / 150) * 0.2
            this.ctx.beginPath()
            this.ctx.strokeStyle = `rgba(102, 126, 234, ${alpha})`
            this.ctx.lineWidth = 0.6
            this.ctx.moveTo(this.particles[i].x, this.particles[i].y)
            this.ctx.lineTo(this.particles[j].x, this.particles[j].y)
            this.ctx.stroke()
          }
        }
      }
      
      // 更新和绘制粒子
      this.particles.forEach(p => {
        p.x += p.vx
        p.y += p.vy
        
        if (p.x < 0 || p.x > this.canvas.width) p.vx *= -1
        if (p.y < 0 || p.y > this.canvas.height) p.vy *= -1
        
        this.ctx.beginPath()
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2)
        this.ctx.fillStyle = p.color + p.opacity + ')'
        this.ctx.fill()
      })
      
      this.animationId = requestAnimationFrame(() => this.animateParticles())
    },
    handleCardHover (e) {
      const card = e.currentTarget
      card.classList.add('hovered')
    },
    handleCardLeave (e) {
      const card = e.currentTarget
      card.classList.remove('hovered')
    },
    handleMouseMove (e) {
      if (this.mouseFollowerTimeout) {
        clearTimeout(this.mouseFollowerTimeout)
      }
      this.showMouseFollower = true
      const container = this.$refs.container
      if (container) {
        const rect = container.getBoundingClientRect()
        this.$refs.mouseFollower.style.left = (e.clientX - rect.left - 100) + 'px'
        this.$refs.mouseFollower.style.top = (e.clientY - rect.top - 100) + 'px'
      }
      this.mouseFollowerTimeout = setTimeout(() => {
        this.showMouseFollower = false
      }, 2000)
    }
  },
  mounted () {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
    this.$nextTick(() => {
      this.initCanvas()
      this.$refs.container.addEventListener('mousemove', this.handleMouseMove)
    })
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
    if (this.animationId) cancelAnimationFrame(this.animationId)
    if (this.$refs.container) {
      this.$refs.container.removeEventListener('mousemove', this.handleMouseMove)
    }
  }
}
</script>

<style>
/* 全局隐藏滚动条 */
html, body, #app {
  overflow: hidden !important;
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>

<style scoped>
.welcome-container {
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(135deg, #0a0a1a 0%, #1a1a3a 50%, #0a0a1a 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: crosshair;
}

/* 粒子画布 */
.particles-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

/* 网格背景 */
.grid-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(102, 126, 234, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(102, 126, 234, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  z-index: 0;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: perspective(500px) rotateX(60deg) translateY(0); }
  100% { transform: perspective(500px) rotateX(60deg) translateY(50px); }
}

/* 浮动光球 */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  animation: float 10s ease-in-out infinite;
  z-index: 0;
}

.orb-1 {
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.5) 0%, transparent 70%);
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.orb-2 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 119, 114, 0.4) 0%, transparent 70%);
  bottom: -100px;
  right: -100px;
  animation-delay: -4s;
}

.orb-3 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(118, 75, 162, 0.5) 0%, transparent 70%);
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
  animation-delay: -7s;
}

.orb-4 {
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(74, 222, 128, 0.3) 0%, transparent 70%);
  bottom: 20%;
  left: 5%;
  animation-delay: -2s;
}

@keyframes float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  25% { transform: translate(30px, -40px) scale(1.08); }
  50% { transform: translate(-15px, 25px) scale(0.95); }
  75% { transform: translate(-40px, -15px) scale(1.05); }
}

/* 鼠标跟随光效 */
.mouse-follower {
  position: absolute;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.15) 0%, transparent 70%);
  pointer-events: none;
  z-index: 2;
  transition: left 0.3s ease-out, top 0.3s ease-out;
}

/* 扫描线 */
.scanline {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.6), rgba(255, 119, 114, 0.4), transparent);
  animation: scan 6s linear infinite;
  z-index: 5;
}

.scanline-2 {
  animation-delay: -3s;
  background: linear-gradient(90deg, transparent, rgba(255, 119, 114, 0.4), rgba(102, 126, 234, 0.6), transparent);
}

@keyframes scan {
  0% { top: -5%; opacity: 0; }
  5% { opacity: 1; }
  95% { opacity: 1; }
  100% { top: 105%; opacity: 0; }
}

/* 内容区域 */
.welcome-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 40px;
  max-width: 1200px;
}

/* 时间显示 */
.time-display {
  margin-bottom: 40px;
  animation: fadeSlideDown 1s ease 0.2s both;
}

.time-text {
  font-family: 'SF Mono', 'Fira Code', 'Courier New', monospace;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 4px;
  padding: 8px 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(102, 126, 234, 0.2);
  border-radius: 4px;
}

@keyframes fadeSlideDown {
  from { opacity: 0; transform: translateY(-30px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 3D标题 */
.title-3d-wrapper {
  perspective: 1000px;
  margin-bottom: 20px;
  animation: fadeSlideUp 1s ease 0.4s both;
}

.title-3d {
  position: relative;
  font-size: 80px;
  font-weight: 900;
  margin: 0;
  letter-spacing: 10px;
  transform-style: preserve-3d;
}

.title-layer {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.title-layer-back {
  color: transparent;
  -webkit-text-stroke: 2px rgba(102, 126, 234, 0.3);
  transform: translateX(-50%) translateZ(-30px) scale(1.1);
  filter: blur(4px);
}

.title-layer-front {
  color: #fff;
  text-shadow: 
    0 0 10px rgba(102, 126, 234, 0.8),
    0 0 20px rgba(102, 126, 234, 0.6),
    0 0 40px rgba(102, 126, 234, 0.4),
    0 0 80px rgba(102, 126, 234, 0.2);
  animation: titleFloat 4s ease-in-out infinite;
}

@keyframes titleFloat {
  0%, 100% { transform: translateX(-50%) translateY(0); }
  50% { transform: translateX(-50%) translateY(-8px); }
}

.title-char {
  display: inline-block;
  animation: charPop 0.6s ease both;
}

@keyframes charPop {
  0% { opacity: 0; transform: scale(0.5) translateY(20px); }
  60% { transform: scale(1.1) translateY(-5px); }
  100% { opacity: 1; transform: scale(1) translateY(0); }
}

@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 霓虹副标题 */
.neon-subtitle {
  font-size: 26px;
  color: #fff;
  margin: 0 0 30px 0;
  letter-spacing: 8px;
  text-shadow: 
    0 0 5px rgba(255, 119, 114, 0.8),
    0 0 10px rgba(255, 119, 114, 0.6),
    0 0 20px rgba(255, 119, 114, 0.4);
  animation: fadeSlideUp 1s ease 0.8s both;
}

.subtitle-char {
  display: inline-block;
  animation: charFadeIn 0.5s ease both;
}

@keyframes charFadeIn {
  from { opacity: 0; filter: blur(10px); }
  to { opacity: 1; filter: blur(0); }
}

/* 霓虹分割线 */
.neon-line {
  width: 300px;
  height: 2px;
  margin: 0 auto 40px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.8), transparent);
  animation: fadeSlideUp 1s ease 1s both;
  position: relative;
  overflow: visible;
}

.neon-line-inner {
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 6px;
  background: linear-gradient(90deg, transparent, #667eea, transparent);
  border-radius: 50%;
  animation: lineGlow 2s ease-in-out infinite;
}

@keyframes lineGlow {
  0%, 100% { opacity: 0.5; width: 80px; }
  50% { opacity: 1; width: 120px; }
}

/* 功能卡片 */
.feature-cards {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  animation: fadeSlideUp 1s ease 1.3s both;
}

.feature-card {
  position: relative;
  width: 160px;
  padding: 24px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.8), transparent);
  opacity: 0;
  transition: opacity 0.3s;
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-card:hover {
  transform: translateY(-8px) scale(1.02);
  border-color: rgba(102, 126, 234, 0.4);
  box-shadow: 
    0 20px 40px rgba(0, 0, 0, 0.3),
    0 0 30px rgba(102, 126, 234, 0.15);
}

.feature-card.hovered {
  transform: translateY(-8px) scale(1.02);
}

.card-glow {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at center, rgba(102, 126, 234, 0.15) 0%, transparent 50%);
  opacity: 0;
  transition: opacity 0.4s;
  pointer-events: none;
}

.feature-card:hover .card-glow {
  opacity: 1;
}

.card-icon {
  font-size: 32px;
  margin-bottom: 12px;
  transition: transform 0.3s;
}

.feature-card:hover .card-icon {
  transform: scale(1.2);
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 6px;
}

.card-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

/* 技术栈徽章 */
.tech-stack {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  animation: fadeSlideUp 1s ease 2s both;
}

.tech-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 18px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 25px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 1px;
  backdrop-filter: blur(10px);
  transition: all 0.3s;
}

.tech-badge:hover {
  background: rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.4);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
}

.badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  animation: dotPulse 2s ease-in-out infinite;
}

@keyframes dotPulse {
  0%, 100% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
}

/* 底部状态 */
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 30px;
  z-index: 10;
  animation: fadeSlideUp 1s ease 2.5s both;
}

.corner-decor {
  position: absolute;
  width: 40px;
  height: 40px;
  border: 2px solid rgba(102, 126, 234, 0.3);
}

.corner-decor.top-left {
  top: 20px;
  left: 20px;
  border-right: none;
  border-bottom: none;
}

.corner-decor.top-right {
  top: 20px;
  right: 20px;
  border-left: none;
  border-bottom: none;
}

.corner-decor.bottom-left {
  bottom: 80px;
  left: 20px;
  border-right: none;
  border-top: none;
}

.corner-decor.bottom-right {
  bottom: 80px;
  right: 20px;
  border-left: none;
  border-top: none;
}

.status-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.pulse-ring {
  width: 10px;
  height: 10px;
  background: #4ade80;
  border-radius: 50%;
  position: relative;
  animation: pulse 2s ease-in-out infinite;
}

.pulse-ring::before {
  content: '';
  position: absolute;
  top: -4px;
  left: -4px;
  right: -4px;
  bottom: -4px;
  border-radius: 50%;
  border: 2px solid #4ade80;
  animation: pulseRing 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}

@keyframes pulseRing {
  0% { transform: scale(1); opacity: 1; }
  100% { transform: scale(2); opacity: 0; }
}

.status-text {
  font-family: 'SF Mono', 'Fira Code', monospace;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 3px;
}

.footer-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
}

.decor-line {
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(102, 126, 234, 0.3), transparent);
}

.decor-text {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.25);
  letter-spacing: 2px;
}

/* 响应式 */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 48px;
    letter-spacing: 5px;
  }
  
  .neon-subtitle {
    font-size: 18px;
    letter-spacing: 4px;
  }
  
  .feature-cards {
    gap: 16px;
  }
  
  .feature-card {
    width: 140px;
    padding: 20px 12px;
  }
  
  .orb-1 { width: 250px; height: 250px; }
  .orb-2 { width: 200px; height: 200px; }
  .orb-3 { width: 150px; height: 150px; }
  .orb-4 { width: 100px; height: 100px; }
  
  .title-3d {
    font-size: 50px;
    letter-spacing: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue